import { Routes } from '@angular/router';

import { OfflineComponent } from './offline/offline.component';

export const OFFLINE_ROUTES: Routes = [
	{
		path: '',
		component: OfflineComponent,
		data: { title: 'dottnet.menu.offline' }
	}
];

